<template>
  <div id="app">
    <QRCode text="https://example.com"/>
  </div>
</template>

<script>
import QRCode from "@/components/QRCode";

export default {
  name: 'App',
  components: {
    QRCode
  }
}
</script>

<style>
#app {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
